module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture16-e08500e129723010cb7ab7760105c0d6.jpg";